<template>
  <span>
  <button
    v-if="isVisible && !isReadOnly && this.orderMetadata != null"
    @click="showSignatureLockMessage()"
    class="btn btn-dark"
    :disabled="isReady"
  >
    <i class="tim-icons icon-single-copy-04"></i> {{ next }} ORDER
  </button>
  <tool-tip v-on:updateToolTip="updateToolTip($event)" v-if="isVisible && ordertype_tooltip_NAME" :name="ordertype_tooltip_NAME" :description="ordertype_tooltip_DESCRIPTION" :editable="editable"></tool-tip>
</span>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import swal from "sweetalert2";
import Util from "../../../../util/util";
import  toolTip  from "../../Tooltip";
 

export default {
  name: "change-order-status",
  props: ["isReadOnly"],
  components:{
    toolTip,

  },

  data() {
    return {
      ready: false,
      ordertype_tooltip_NAME : '',
      ordertype_tooltip_DESCRIPTION: '',
      statusTab: [
        { current: "DRAFT", next: "SUBMIT" },
        { current: "SUBMITTED", next: "AUTHORIZE" },
        { current: "AUTHORIZED", next: "RECEIVE" },
        { current: "RECEIVED", next: "RETURN" },
        { current: "RETURNED", next: "INVOICE" },
        { current: "INVOICED", next: "BILL" },
      ],
    };
  },
  async created() {
    var ctx = this;
    ctx.$store.dispatch("clearAllOrderData");

    if (ctx.$route.params.id > 0) {
      ctx.getOrderMetadata(ctx.$route.params.id).then(() => {
        ctx.ready = false;
      });
    }
  },
  async mounted(){
    await this.getAllTooltips()
    this.loadToolTips()
  },
  computed: {
    ...mapGetters({
      preOrderStatus: "preOrderDetail/preOrderStatus",
      agreementInformationStatus:
        "agreementInformation/agreementInformationStatus",
      deliveryInformationStatus:
        "deliveryInformation/deliveryInformationStatus",
      transactionInformationStatus:
        "transactionInformation/transactionInformationStatus",
      financeOfficeStatus: "financeOffice/financeOfficeInformationStatus",
      lineItemStatus: "lineItem/lineItemStatus",
      replacementItemStatus: "replacementItem/replacementItemStatus",
      authorizedRequestorSubmitStatus: "authorizedRequestor/authorizedRequestorSubmitStatus",
      authorizedAcceptorSubmitStatus: "authorizedAcceptor/authorizedAcceptorSubmitStatus",
      
      authorizedRatifierAuthorizeStatus: "authorizedRatifier/authorizedRatifierAuthorizeStatus",
      authorizedRequestorAuthorizeStatus: "authorizedRequestor/authorizedRequestorAuthorizeStatus",
      authorizedAcceptorAuthorizeStatus:"authorizedAcceptor/authorizedAcceptorAuthorizeStatus",
      lineItemReceiptStatus: "lineItemReceipt/lineItemReceiptStatus",
      replacementItemReceiptStatus:"replacementItemReceipt/replacementItemReceiptStatus",
      inspectedReceivedByStatus: "inspectedReceivedBy/inspectedReceivedByStatus",
      returnReplacementReceiptAcknowledgmentStatus:
        "returnReplacementReceiptAcknowledgment/returnReplacementReceiptAcknowledgmentStatus",
      fundCitationStatus: "fundCitation/fundCitationStatus",
      lineItemInvoiceStatus: "lineItemInvoice/lineItemInvoiceStatus",
      replacementItemInvoiceStatus: "replacementItemInvoice/replacementItemInvoiceStatus",
      supplyOfficialStatus: "supplyOfficial/supplyOfficialStatus",
      financeInformationStatus: "financeInformation/financeInformationStatus",
      bankingInformationStatus: "bankingInformation/bankingInformationStatus",
      disbursingCollectionInformationStatus: "disbursingCollectionInformation/disbursingCollectionInformationStatus",
      financialRepresentativeStatus: "financialRepresentative/financialRepresentativeStatus",
      orderMetadata: "orderMetadata/orderMetadata",
      toolTips: "tooltip/tooltips",
      editable: "tooltip/editable"
    }),
    isVisible() {
      if (this.orderMetadata) {
        return [
          "DRAFT",
          "SUBMITTED",
          "INVOICED",
          "AUTHORIZED",
          "RECEIVED",
          "RETURNED"
        ].includes(`${this.orderMetadata.orderStatus}`);
      }
    },

    isReady() {
      return this.ready;
    },
    next() {
      let ctx = this;
      let item = {};

      // skip the return/replacement if it is monatory paymentmethod
      if(ctx.orderMetadata.orderStatus == Util.ORDER_STATUS_RECEIVED) {
        if(ctx.orderMetadata.paymentMethodId === Util.MONETARY) {
          item = ctx.statusTab.find(i => i.current == Util.ORDER_STATUS_RETURNED);
        } else {
          item = ctx.statusTab.find(
            (i) => i.current === ctx.orderMetadata.orderStatus
          );
        }
      } else {
        item = ctx.statusTab.find(
          (i) => i.current === ctx.orderMetadata.orderStatus
        );
      }
      return item.next;
    },
  },
  methods: {
    ...mapActions({
      getOrderMetadata: "orderMetadata/getOrderMetadata",
      submitSubmission: "orderMetadata/submitSubmission",
      submitAuthorization: "orderMetadata/submitAuthorization",
      submitReceiving: "orderMetadata/submitReceiving",
      submitReturnReplacement: "orderMetadata/submitReturnReplacement",
      submitInvoice: "orderMetadata/submitInvoice",
      submitBilled: "orderMetadata/submitBilled",
      getAuthorizedRatifierAuthorizeStatus: "authorizedRatifier/getAuthorizedRatifierAuthorizeStatus",
      getAuthorizedRequestorAuthorizeStatus: "authorizedRequestor/getAuthorizedRequestorAuthorizeStatus",
      getAuthorizedAcceptorAuthorizeStatus: "authorizedAcceptor/getAuthorizedAcceptorAuthorizeStatus",
      getLineItemReceiptStatus: "lineItemReceipt/getLineItemReceiptStatus",
      getReplacementItemReceiptStatus:"replacementItemReceipt/getReplacementItemReceiptStatus",
      getInspectedReceivedByStatus: "inspectedReceivedBy/getInspectedReceivedByStatus",
      getReturnReplacementReceiptAcknowledgmentStatus:
        "returnReplacementReceiptAcknowledgment/getReturnReplacementReceiptAcknowledgmentStatus",
      getFundCitationStatus: "fundCitation/getFundCitationStatus",
      getLineItemInvoiceStatus: "lineItemInvoice/getLineItemInvoiceStatus",
      getReplacementItemInvoiceStatus: "replacementItemInvoice/getReplacementItemInvoiceStatus",
      getSupplyOfficialStatus: "supplyOfficial/getSupplyOfficialStatus",
      getFinanceInformationStatus: "financeInformation/getFinanceInformationStatus",
      getBankingInformationStatus: "bankingInformation/getBankingInformationStatus",
      getFinancialRepresentativeStatus: "financialRepresentative/getFinancialRepresentativeStatus",
      getDisbursingCollectionInformationStatus: 
        "disbursingCollectionInformation/getDisbursingCollectionInformationStatus",
      getReconciliationStatusInformation: "reconciliationStatus/getReconciliationStatusInformation",
      getAllTooltips: "tooltip/getToolTips"
    }),
    showSignatureLockMessage() {
      this.ready = true;
      if (this.orderMetadata.orderStatus === "DRAFT") {
        this.statusSubmit();
      } else {
        new swal({
          title: `${this.next} ORDER?`,
          text: `Clicking ok will lock any signature(s) before this point.`,
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#10b45a",
          cancelButtonColor: "red",
          confirmButtonText: `Ok`,
          reverseButtons: true
        })
          .then((result) => {
            if (result.value) {
              this.statusSubmit();
            } else {
              this.ready = false;
            }
          })
          .catch((e) => {
            if (this.ready === true) this.ready = false;
          });
      }
    },
    loadToolTips(){
    const orderTypeVal =   this.toolTips.find(e => e.name === "orderType")
    
    if(orderTypeVal && orderTypeVal.status){
      this.ordertype_tooltip_DESCRIPTION = orderTypeVal.description ? orderTypeVal.description :  null
      this.ordertype_tooltip_NAME = orderTypeVal.name ? orderTypeVal.name :  null
    }
    return 
      
    },
    updateToolTip(updatedData){
      this.loadToolTips()
      },
    statusSubmit() {
      let ctx = this;
      ctx.ready = true;

      switch (ctx.orderMetadata.orderStatus) {
        case "DRAFT":
          ctx.validateSubmission();
          break;
        case "SUBMITTED":
          ctx.validateAuthorization();
          break;
        case "AUTHORIZED":
          ctx.validateReceived();
          break;
        case Util.ORDER_STATUS_RECEIVED:
          if(ctx.orderMetadata.paymentMethodId !== Util.MONETARY) {
            ctx.validateReturn();
            break;
          } else {
            ctx.validateReturnMonetory();
            break;
          }
         
        case "RETURNED":
          ctx.validateInvoice();
          break;
        case "INVOICED":
          ctx.validateBilled();
          break;
        default:
          break;
      }
    },
    IsSubmissionStepComplete() {
      let submissionError = [];
      if(!this.preOrderStatus) submissionError.push("Pre Order");
      if(!this.agreementInformationStatus) submissionError.push("Agreement Information");
      if(!this.deliveryInformationStatus) submissionError.push("Delivery Information");
      if(!this.transactionInformationStatus) submissionError.push("Transaction Information");
      if(!this.lineItemStatus) submissionError.push("Line Item");
      if(!this.replacementItemStatus) submissionError.push("Replacement Item");
      if(!this.financeOfficeStatus) submissionError.push("Finance Offices")
      if(!this.authorizedRequestorSubmitStatus) submissionError.push("Authorized Requestor");
      if(!this.authorizedAcceptorSubmitStatus) submissionError.push("Authorized Acceptor");
    let submissionStatus = this.preOrderStatus &&
          this.agreementInformationStatus &&
          this.deliveryInformationStatus &&
          this.transactionInformationStatus &&
          this.lineItemStatus &&
          this.replacementItemStatus &&
          this.financeOfficeStatus &&
          this.authorizedRequestorSubmitStatus &&
          this.authorizedAcceptorSubmitStatus;

      if(submissionError) {
        return ([
         submissionStatus, 
          submissionError.join(", ")
        ]);
      }
      return [submissionStatus];
    },
    validateSubmission() {
      let ctx = this;
      const submissionCheck  = this.IsSubmissionStepComplete();

      // if you are here it means you requre submitally but first pass our checks
      if (!submissionCheck[0]) {
        let updated_string = submissionCheck[1].replace(/,([^,]*)$/, " and$1");
        this.$toast.error(
          `Submission Incomplete - Please verify: ${updated_string} modules are complete.`
        );
        ctx.ready = false;
        return false; // failed
      }

      //if you are here you are in the clear so as long as you pass the server checks
      return ctx
        .submitSubmission(ctx.$route.params.id)
        .then(() => {
          ctx.$toast.success(
            `Order Submitted!! Requisition Number: ${ctx.orderMetadata.requisitionNumber}`
          );
          ctx.checkAuthorizationModules();
          ctx.ready = false;

          return true;
        })
        .catch((errorMessage) => {
          this.$toast.error(`client response: ${errorMessage}`);
          ctx.ready = false;
          return false;
        });
    },
    IsAuthorizationStepComplete() {
      let authorizedError = [];
      let authorizedStatus =  this.authorizedRequestorAuthorizeStatus &&
          this.authorizedAcceptorAuthorizeStatus && (this.authorizedRatifierAuthorizeStatus);

      if(!this.authorizedRatifierAuthorizeStatus) authorizedError.push("Ratification (Document Upload)");
      if(!this.authorizedRequestorAuthorizeStatus) authorizedError.push("Authorized Requestor (Signature)");
      if(!this.authorizedAcceptorAuthorizeStatus) authorizedError.push("Authorized Acceptor (Signature)");
      if(authorizedError) {
        return ([
          authorizedStatus,
          authorizedError.join(", ")
        ]);
      } 
      return [authorizedStatus];
    },
    validateAuthorization() {
      let ctx = this;
       const authorizationCheck  = this.IsAuthorizationStepComplete();
      // if you are here it means you requre submitally but first pass our checks
      if (!this.IsSubmissionStepComplete()[0] || !authorizationCheck[0]) {
        this.$toast.error(
          `Authorization: Incomplete! - Please verify ${authorizationCheck[1]} module is complete`
        );
        ctx.ready = false;
        return false; // failed
      }

      //if you are here you are in the clear so as long as you pass the server checks
      return ctx
        .submitAuthorization(ctx.$route.params.id)

        .then(() => {
          ctx.checkReceiptModules();
          ctx.ready = false;
          return true;
        })
        .catch((errorMessage) => {
          this.$toast.error(`client response: ${errorMessage}`);
          ctx.ready = false;
          return false;
        });
    },
    IsReceivedStepComplete() {
       let receivedError = [];
      let receivedStatus =  this.lineItemReceiptStatus &&
        this.inspectedReceivedByStatus;

       if(!this.lineItemReceiptStatus) receivedError.push("Receipt Quantities") ;
       if(!this.inspectedReceivedByStatus) receivedError.push("Inspected / Received By") ;
       if(receivedError){
      return ([
        receivedStatus,
        receivedError.join(", ")
      ]);
       }
       return [receivedStatus];
    },
    
    validateReceived() {
      let ctx = this;
      const receivedCheck  = this.IsReceivedStepComplete();
      // if you are here it means you requre submitally but first pass our checks
      if (
        !this.IsSubmissionStepComplete()[0] ||
        !this.IsAuthorizationStepComplete()[0] ||
        !receivedCheck[0]
      ) {
        this.$toast.error(
          `Receiving: Incomplete! - Please verify ${receivedCheck[1]} modules are complete`
        );
        ctx.ready = false;
        return false; // failed
      }
      //if you are here you are in the clear so as long as you pass the server checks
      return ctx
        .submitReceiving(ctx.$route.params.id)
        .then(() => {
          ctx.checkReturnReplacementModules();
          ctx.ready = false;
          return true;
        })
        .catch((errorMessage) => {
          this.$toast.error(`client response: ${errorMessage}`);
          ctx.ready = false;
          return false;
        });
    },
        
    IsReturnReplacementComplete() {
      let isRik = this.orderMetadata.paymentMethodId !== Util.MONETARY;
      let error = [];
      let status = null;
      if(isRik) {
        status = this.returnReplacementReceiptAcknowledgmentStatus && this.replacementItemReceiptStatus;
      } else {
        status = this.returnReplacementReceiptAcknowledgmentStatus;
      }
      if(!this.returnReplacementReceiptAcknowledgmentStatus) 
        error.push("Return Replacement Acknowledgement");
      if(!this.replacementItemReceiptStatus)
        error.push("Replacement Receipt Quantities")
      if(error) {
        return ([
          status,
          error.join('/ ')
        ]);
      }

      return [status];
    },

    validateReturnMonetory() {
      let ctx = this;
      // why does monetory check need this returnreplacementcomplete check?
      let returnReplacementCheck = this.IsReturnReplacementComplete();
      if (
        !this.IsSubmissionStepComplete()[0] ||
        !this.IsAuthorizationStepComplete()[0] ||
        !this.IsReceivedStepComplete()[0] ||
        !returnReplacementCheck[0]
      ) {
        this.$toast.error(
          `Return / Replacement: Incomplete! - Please verify ${returnReplacementCheck[1]} modules are complete`
        );
        ctx.ready = false;
        return false; // failed
      }
      return ctx.submitReturnReplacement(ctx.$route.params.id).then((d) => {
        
        //ctx.checkInvoiceModules().then() is not working, so I have to use the promise all directly here
        let promise = Promise.all([this.getFundCitationStatus(this.$route.params.id), this.getLineItemInvoiceStatus(this.$route.params.id), this.getReplacementItemInvoiceStatus(this.$route.params.id), this.getSupplyOfficialStatus(this.$route.params.id)]);
        promise.then(data => {
          // make sure validateInvoice is called after the returnreplacement is finished
          ctx.validateInvoice();
          ctx.ready = false;
          return true;
        });
       
      })
      .catch((errorMessage) => {
        this.$toast.error(`client response: ${errorMessage}`);
        ctx.ready = false;
        return false;
      });
    },
    validateReturn() {
      let ctx = this;
      let returnReplacementCheck = this.IsReturnReplacementComplete();

      if (
        !this.IsSubmissionStepComplete()[0] ||
        !this.IsAuthorizationStepComplete()[0] ||
        !this.IsReceivedStepComplete()[0] ||
        !returnReplacementCheck[0]
      ) {
        this.$toast.error(
          `Return / Replacement: Incomplete! - Please verify ${returnReplacementCheck[1]} modules are complete`
        );
        ctx.ready = false;
        return false; // failed
      }

      return ctx.submitReturnReplacement(ctx.$route.params.id).then((d) => {
        ctx.checkInvoiceModules();
        ctx.ready = false;
        return true;
      })
      .catch((errorMessage) => {
        this.$toast.error(`client response: ${errorMessage}`);
        ctx.ready = false;
        return false;
      });
    },
    IsInvoiceStepComplete() {
      let invoiceError = [];
      let invoiceStatus =   this.fundCitationStatus &&
        this.lineItemInvoiceStatus &&
        this.replacementItemInvoiceStatus &&
        this.supplyOfficialStatus;

       if(!this.fundCitationStatus) invoiceError.push("Fund Citation") ;
       if(!this.lineItemInvoiceStatus) invoiceError.push("Assign Line Items to Fund Citation") ;
       if(!this.replacementItemInvoiceStatus) invoiceError.push("Assign Replacement Line Item to Fund Citation") ;
       if(!this.supplyOfficialStatus) invoiceError.push("Supplying/Invoicing Official") ;
       if(invoiceError){
      return ([
        invoiceStatus,
        invoiceError.join(", ")
      ]);
       }
       return [invoiceStatus];
    },
    
    validateInvoice() {
      let ctx = this;
      const invoiceCheck  = this.IsInvoiceStepComplete();
      // if you are here it means you requre submitally but first pass our checks
      if (
        !this.IsSubmissionStepComplete()[0] ||
        !this.IsAuthorizationStepComplete()[0] ||
        !this.IsReceivedStepComplete()[0] ||
        !invoiceCheck[0] ||
        !this.IsReturnReplacementComplete()[0]
      ) {
        this.$toast.error(
          `Invoiced: Incomplete! - Please verify ${invoiceCheck[1]} modules are complete`
        );
        ctx.ready = false;
        return false; // failed
      }

      //if you are here you are in the clear so as long as you pass the server checks
      return ctx
        .submitInvoice(ctx.$route.params.id)
        .then(() => {
          ctx.checkBilledModules();
          ctx.ready = false;
          return true;
        })
        .catch((errorMessage) => {
          this.$toast.error(`client response: ${errorMessage}`);
          ctx.ready = false;
          return false;
        });
    },
    IsBilledStepComplete() {
      let billedError = [];
      let billedStatus = this.bankingInformationStatus;

       if(!this.bankingInformationStatus) billedError.push("Banking Information");


       if(billedError)  {
          return ([billedStatus, billedError.join(", ")]);
       }
       
       return [billedStatus];
    },
    validateBilled() {
      let ctx = this;
      const billedCheck  = this.IsBilledStepComplete();
      // if you are here it means you requre submitally but first pass our checks
      if (
        !this.IsSubmissionStepComplete()[0] ||
        !this.IsAuthorizationStepComplete()[0] ||
        !this.IsReceivedStepComplete()[0] ||
        !this.IsReturnReplacementComplete()[0] ||
        !this.IsInvoiceStepComplete()[0] ||
        !billedCheck[0]
      ) {
        this.$toast.error(
          `Billed: Incomplete! - Please verify ${billedCheck[1]} modules are complete`
        );
        ctx.ready = false;
        return false; // failed
      }
      //if you are here you are in the clear so as long as you pass the server checks
      return ctx
        .submitBilled(ctx.$route.params.id)
        .then(() => {
          ctx.checkCompletionModules();
          ctx.ready = false;
          return true;
        })
        .catch((errorMessage) => {
          this.$toast.error(`client response: ${errorMessage}`);
          ctx.ready = false;
          return false;
        });
    },
    checkAuthorizationModules() {
      Promise.all([this.getAuthorizedRatifierAuthorizeStatus(this.$route.params.id), this.getAuthorizedAcceptorAuthorizeStatus(this.$route.params.id), this.getAuthorizedRequestorAuthorizeStatus(this.$route.params.id)]);
    },
    checkReceiptModules() {
      Promise.all([this.getLineItemReceiptStatus(this.$route.params.id), this.getInspectedReceivedByStatus(this.$route.params.id)]);
    },
    checkReturnReplacementModules() {
      Promise.all([this.getReplacementItemReceiptStatus(this.$route.params.id), this.getReturnReplacementReceiptAcknowledgmentStatus(this.$route.params.id)]);
    },
    checkInvoiceModules() {
       Promise.all([this.getFundCitationStatus(this.$route.params.id), this.getLineItemInvoiceStatus(this.$route.params.id), this.getReplacementItemInvoiceStatus(this.$route.params.id), this.getSupplyOfficialStatus(this.$route.params.id)]);
    },
    checkBilledModules() {
      Promise.all([this.getBankingInformationStatus(this.$route.params.id)]);
    },
    checkCompletionModules() {
      Promise.all([this.getDisbursingCollectionInformationStatus(this.$route.params.id), this.getReconciliationStatusInformation(this.$route.params.id), this.getFinancialRepresentativeStatus(this.$route.params.id)])
    }
  },
};
</script>
